import { Inject, Component, Input, ViewEncapsulation } from "@angular/core";
import { Assortment, Product } from "../shared/models";
import { Breakpoints, BreakPointAccessor } from "../../shared/utils";
import { BaseComponent } from "../shared";
import { RouteRedirector } from "../shared/providers";
import { ConfRouteParams } from "../configurator/providers";
// Aritco
import { AritcoRequest } from "../shared/models";
import { AritcoStore } from "../shared/aritco/aritcoStore";
import { ModelFactory } from "../shared/providers";
import { ChangeDetectorRef } from "@angular/core";
// End

@Component({
  selector: 'product-detail',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './detailComponent.html'
})
export class DetailComponent extends BaseComponent {

  public readonly DEFAULT_IMAGE = "configuration";
  public image: string = "";
  public imageType: string = "svg";
  public isVault: boolean = false;
  public imageSet: string;
  // Aritco
  public leadTime: string = "";
  // End

  public isProduct = false;

  _assortment: Assortment;
  detailStyle: CSSStyleDeclaration;
  @Input() set product(value: Assortment) {
    this._assortment = value;
    this.isProduct = value instanceof Product;
    this.image = this.hasImage ? this._assortment.imageRelativeUrl : this.DEFAULT_IMAGE;
    this.isVault = this.hasImage;
    this.imageType = this.hasImage ? 'png' : 'svg';
    this.imageSet = this.hasImage ? '' : 'primary-light';
    // Aritco
    this.leadTime = '';
    let aritcoRequest = this.modelFactory.createRequestOrCommand<AritcoRequest>(AritcoRequest.name);
    aritcoRequest.leadTime = true;
    aritcoRequest.productId = value.longId;

    this.aritcoStore.get(aritcoRequest).subscribe(response => {

      this.leadTime = response.message;

      this.cdr.detectChanges();
      this.unblockUI();

    }).unsubscribeOn(this.unsubscribeSubject);
    // End

    this.updateStyle();
  };

  constructor(
    @Inject(RouteRedirector) public routeRedirector: RouteRedirector,
    @Inject(BreakPointAccessor) public breakPointAccessor: BreakPointAccessor,
    // Aritco
    public aritcoStore: AritcoStore,
    public modelFactory: ModelFactory,
    public cdr: ChangeDetectorRef,
    // End
  ) {
    super();
  }

  updateStyle(): void {
    let calMinWidth: string;

    if (this.breakPointAccessor.equalOrDown(Breakpoints.md)) {
      calMinWidth = "100%";
    }
    else {
      calMinWidth = "600px";
    }

    this.detailStyle = <CSSStyleDeclaration>{
      maxWidth: calMinWidth
    }

  }

  get hasImage(): boolean {
    return this._assortment.imageRelativeUrl != "";
  }

  onConfigure(): void {
    this.createConfiguration(this._assortment.longId);
  }

  /**
  * Create the configuration
  * @param productId
  */
  createConfiguration(productId: number) {
    this.routeRedirector.redirectToEditor(<ConfRouteParams>{ productId: productId });
  }
}